import React from "react";
import { Box, Heading, Text, Stack, Flex } from "@chakra-ui/react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import LoadingSpinner from "../../components/LoadingSpinner";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function GraficoServicosAcolhimento({
  dados,
  loadingGraficoServico,
}) {
  const labels = [
    "Serviço de Acolhimento Institucional (Modalidade Abrigo Institucional)",
    "Serviço de Acolhimento Familiar",
    "Serviço de Acolhimento Institucional (Modalidade Casa Lar)",
  ];

  const values = [
    dados.quantidadeInstitucional ?? 0,
    dados.quantidadeFamiliar ?? 0,
    dados.quantidadeCasaLar ?? 0,
  ];

  const percentages = values.map((v) => ((v / dados?.total) * 100).toFixed(0));
  const maxValue = Math.max(...values);

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: ["#5689A6", "#7ACEBA", "#B5CEC8"],
        hoverBackgroundColor: ["#5689A6", "#7ACEBA", "#B5CEC8"],
        borderRadius: 12,
        barThickness: 100,
        minBarLength: 5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y}`,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        beginAtZero: true,
        ticks: {
          callback: (value) => `${value}`,
          stepSize: Math.ceil(maxValue / 5),
        },
        suggestedMax: maxValue + 1,
      },
    },
  };

  return (
    <Box
      p={6}
      shadow={"md"}
      backgroundColor="#F7F8FB"
      rounded={"lg"}
      border="1px solid #E0E6ED"
    >
      {loadingGraficoServico ? (
        <Flex h={"100%"} alignItems={"center"} justifyContent={"center"}>
          <LoadingSpinner />
        </Flex>
      ) : (
        <>
          <Heading fontSize="lg" mb={4} color="#2D2F44">
            Serviços de Acolhimento
          </Heading>

          <Box width={{ base: "100%", lg: "70%" }} height={"200px"} mb={6}>
            <Bar data={data} options={options} />
          </Box>

          <Stack spacing={3}>
            {labels.map((label, index) => (
              <Flex align="center" key={index}>
                <Box
                  w="14px"
                  h="14px"
                  borderRadius="md"
                  backgroundColor={data.datasets[0].backgroundColor[index]}
                  mr={3}
                />
                <Text fontSize="sm" color="gray.700">
                  {label}{" "}
                  <strong>
                    {values[index]} ({percentages[index]}%)
                  </strong>
                </Text>
              </Flex>
            ))}
          </Stack>
        </>
      )}
    </Box>
  );
}
